import fetchData from "../API/Fetch";
import { store } from "../store";

// Track known user IDs to detect new registrations
const STORAGE_KEY = "ecoludik_known_user_ids";
let isFirstFetch = true;

// Load known user IDs from localStorage
function getKnownUserIds() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? new Set(JSON.parse(stored)) : new Set();
  } catch {
    return new Set();
  }
}

// Save known user IDs to localStorage
function saveKnownUserIds(ids) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...ids]));
  } catch {
    // Ignore storage errors
  }
}

export default async function fetchUsers() {
  let result = await fetchData(`/users/`);
  const users = result ? result : [];

  const knownUserIds = getKnownUserIds();

  // Check for new users (only after first fetch, and only for admins)
  if (!isFirstFetch && users.length > 0) {
    const currentUserDB = store.getState().userDB;

    // Only notify admins
    if (currentUserDB && currentUserDB.admin) {
      const newUsers = users.filter(user => !knownUserIds.has(user.id));

      if (newUsers.length > 0) {
        // Create notification message
        let message;
        if (newUsers.length === 1) {
          message = `🆕 Nouveau collaborateur inscrit : ${newUsers[0].email}`;
        } else {
          message = `🆕 ${newUsers.length} nouveaux collaborateurs inscrits : ${newUsers.map(u => u.email).join(", ")}`;
        }

        store.dispatch({
          type: "snackbar/update",
          payload: {
            open: true,
            message: message,
            severity: "info",
          },
        });
      }
    }
  }

  // Update known user IDs and persist
  const newKnownIds = new Set(users.map(user => user.id));
  saveKnownUserIds(newKnownIds);
  isFirstFetch = false;

  store.dispatch({
    type: "users/update",
    payload: users,
  });
  return result;
}
